// @ts-nocheck
import useSWRMutation, { SWRMutationResponse } from "swr/mutation";
import useHttpClient from "../useHttpClient";
import { AxiosInstance } from "axios";

export type PhoneLoginVerifyResult = {
  token: string;
  isNewUser: boolean;
};

const usePhoneLoginVerify = (): SWRMutationResponse<PhoneLoginVerifyResult, AxiosError, { phoneNumber: string; code: string; source?: string }> => {
  const httpClient: AxiosInstance = useHttpClient();
  return useSWRMutation(
    "phone-login-verify",
    async (_key, { arg }: { arg: { phoneNumber: string; code: string; source?: string } }): Promise<PhoneLoginVerifyResult> =>
      httpClient
        .post("/auth/login/phone/verify-otp", {
          phoneNumber: arg.phoneNumber,
          code: arg.code,
          source: arg.source,
        })
        .then((res) => ({
          token: res.data.data.token,
          isNewUser: Boolean(res.data.data.isNewUser),
        }))
  );
};

export default usePhoneLoginVerify;
